import { SCAppBar } from "@/components/sleep_checkup_v1/SCAppBar";
import Title from "@/components/Title";
import { callOrgMemberUpdateAPI } from "@/pages/org/MemberUpdateAPI";
import { facilityTheme } from "@/theme/themeV1";
import { Box, ThemeProvider, Typography } from "@mui/material";
import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

type Result =
  | { status: "loading" }
  | { status: "success" }
  | { status: "invalid-token" }
  | { status: "cognito-error" };

function isCognitoError(data: unknown): boolean {
  if (typeof data !== "object" || data === null) return false;
  const err = (data as Record<string, unknown>).error;
  if (typeof err !== "object" || err === null) return false;
  return typeof (err as Record<string, unknown>).name === "string";
}

function MemberUpdate() {
  const location = useLocation();
  const [result, setResult] = useState<Result>({ status: "loading" });

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    callOrgMemberUpdateAPI(query.get("token"))
      .then(() => {
        setResult({ status: "success" });
      })
      .catch((err: AxiosError) => {
        const status = err.response?.status;
        if (status === 400 && isCognitoError(err.response?.data)) {
          setResult({ status: "cognito-error" });
        } else {
          setResult({ status: "invalid-token" });
        }
      });
  }, [location]);

  return (
    <ThemeProvider theme={facilityTheme}>
      <>
        <Title title="SLEEP COMPASS" />
        <meta
          name="description"
          content="睡眠健康測定 SLEEP COMPASSの組織用管理画面"
        />
      </>
      <SCAppBar minWidth={1098} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "80px 40px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0px",
            gap: "40px",
            width: "432px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "0px",
              gap: "16px",
            }}
          >
            <Typography variant="h3">ユーザー更新</Typography>
            {result.status === "loading" && (
              <Typography variant="body2" color="text.primary">
                検証中です...
              </Typography>
            )}
            {result.status === "success" && (
              <Typography variant="body2" color="text.primary">
                メールアドレスの更新が完了しました
              </Typography>
            )}
            {result.status === "invalid-token" && (
              <Typography variant="body2" color="text.primary">
                検証リンクが無効、または有効期限が切れています。管理者に再発行を依頼してください。
              </Typography>
            )}
            {result.status === "cognito-error" && (
              <Typography variant="body2" color="text.primary">
                メールアドレスの有効化に失敗しました。管理者にお問い合わせください。
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default MemberUpdate;
